<mat-form-field class="dict-blog-categories">
  <mat-select
    [formControl]="control"
    [required]="required"
    [multiple]="multiple"
    [placeholder]="label"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="categoryFilterCtrl"
        placeholderLabel="Wyszukaj kategorię..."
        noEntriesFoundLabel="Nie znaleziono kategorii"
      >
      </ngx-mat-select-search>
    </mat-option>

    <mat-option
      *ngFor="let category of items"
      [value]="category.uuid"
    >
      {{ category.name }}
    </mat-option>
  </mat-select>

  <button
    *ngIf="(
      (control.value !== null
        && multiple
        && control.value?.hasOwnProperty('length')
        && control.value.length > 0
      )
      || (!multiple && control.value)
    )
    && !required
    && !control.disabled"
    matSuffix
    mat-icon-button
    type="button"
    aria-label="Wyczyść"
    (click)="clearValue(); $event.stopPropagation()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-error *ngIf="control.hasError('required')">
    To pole jest wymagane
  </mat-error>

  <mat-error *ngIf="control.hasError('backendError')">
    {{ control.getError('backendError') }}
  </mat-error>
</mat-form-field>
